/* eslint-disable sonarjs/table-header */
import React from 'react';
import cx from 'classnames';
import moment from 'moment';

import { useNavigate } from 'react-router-dom';
import NextIcon from '../../media/icons/page-next.svg';
import PrevIcon from '../../media/icons/page-prev.svg';

const PAGE_SIZE = 10;

const ProjectsList = ({ projects, handlePageClick, total, page }) => {
  const navigate = useNavigate();

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  //   const handlePageClick = (event) => {
  //     setFilter({ ...filter, page: event.selected });
  //     // const newOffset = (event.selected * PAGE_SIZE) % total;
  //     // console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
  //   };

  return (
    <>
      <div className="main-table">
        {projects.length > 0 ? (
          <table className="projects-table ">
            <thead>
              <tr>
                <th>Project Name</th>
                <th>Created</th>
                <th>Number of Members</th>
                <th>Situational Awareness</th>
                <th>SMART</th>
              </tr>
            </thead>
            <tbody className="hover-effect">
              {projects?.map((project) => (
                <tr key={project.id} className="hover-effect">
                  <td>
                    <div className="flex">
                      <div
                        className={cx(`rounded-full w-4 h-4 my-auto`)}
                        style={{ backgroundColor: project.accent_colour }}
                      />
                      <button
                        type="button"
                        className="mx-4 hover:text-accent text-left"
                        onClick={() => navigate(`/projects/${project.id}`)}
                      >
                        {project.name}
                      </button>
                    </div>
                  </td>
                  <td>{moment(project.created_at).format('MMM Do, YYYY, HH:mm')}</td>
                  <td>{project.members_count}</td>
                  <td>
                    <div
                      className={cx('rounded-full w-[95px] py-1 px-3 text-center', {
                        'bg-[#00CD8F]/10 text-[#00CD8F]': project.situational_awareness_enabled,
                        'bg-[#FF3366]/10 text-[#FF3366]': !project.situational_awareness_enabled,
                      })}
                    >
                      {project.situational_awareness_enabled ? 'Enabled' : 'Disabled'}
                    </div>
                  </td>
                  <td>
                    <div
                      className={cx('rounded-full w-[95px] py-1 px-3 text-center', {
                        'bg-[#00CD8F]/10 text-[#00CD8F]': project.smart_enabled,
                        'bg-[#FF3366]/10 text-[#FF3366]': !project.smart_enabled,
                      })}
                    >
                      {project.smart_enabled ? 'Enabled' : 'Disabled'}
                    </div>
                  </td>
                </tr>
              ))}
              {/* {projects?.map((report) => (
                <tr key={report._id} onClick={() => navigate(report._id)} className={report.type}>
                  <td>
                    <img src={getCategoryIcon(report.type)} alt="" />
                  </td>
                  <td>{report.type}</td>
                  {report.reporter ? (
                    <td>
                      {report.reporter.name}
                      {report.reporter?.email && (
                        <span className="sub-info">{report.reporter.email}</span>
                      )}
                      {report.reporter?.customer && (
                        <span className="sub-info">{report.reporter.customer}</span>
                      )}
                    </td>
                  ) : (
                    <td>Unknown</td>
                  )}
                  <td>
                    {dateFormat(report.timestamp, 'MMM D, YYYY')}
                    <span className="sub-info">{dateFormat(report.timestamp, 'HH:mm:ss')}</span>
                  </td>
                  <td>
                    {report.location && (
                      <>
                        {report.location.reverse && (
                          <span>
                            {report.location.reverse.city},{report.location.reverse.country}
                          </span>
                        )}
                        {report.location ? (
                          <span className="sub-info">
                            <a
                              target="_blank"
                              href={`https://www.google.com/maps/?q=${report.location.latitude},${report.location.longitude}`}
                              rel="noreferrer"
                            >
                              {report.location.latitude},{report.location.longitude}
                            </a>
                          </span>
                        ) : (
                          <span>Unknown Location</span>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              ))} */}
            </tbody>
          </table>
        ) : (
          <table className="reports-table mt-14">
            <tbody>
              <tr>
                <td>No projects to display</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
      <br />

      <div className="flex float-right">
        <div className="text-base flex items-center justify-center mx-2">
          Page {page + 1} of {pageCount}
        </div>
        <button
          type="button"
          onClick={() => handlePageClick('prev')}
          disabled={page + 1 === 1}
          className="bg-accent rounded-md p-2 flex justify-center items-center m-1 disabled:bg-accent/20 disabled:cursor-not-allowed"
        >
          <img className="w-2 h-2 absolute" src={PrevIcon} alt="p" />
        </button>

        <button
          type="button"
          onClick={() => handlePageClick('next')}
          disabled={page + 1 === pageCount}
          className="bg-accent rounded-md p-2 flex justify-center items-center m-1 disabled:bg-accent/20 disabled:cursor-not-allowed"
        >
          <img className="w-2 h-2 absolute" src={NextIcon} alt="n" />
        </button>
      </div>
    </>
  );
};

export default ProjectsList;
